'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var SuccessBanner_module = require('./SuccessBanner.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SuccessBannerC = _ref => {
  let {
    children
  } = _ref;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: SuccessBanner_module["default"].success,
    style: {
      fontFamily: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontFamily) || 'inherit'
    }
  }, children);
};
var SuccessBanner = nthHookTheme.withThemeProvider(SuccessBannerC, {
  themeTokens: ['bodytextDefaultNone']
});

exports["default"] = SuccessBanner;
